export default __webpack_public_path__ + "static/media/navneet-headshot-dark.4bffd739.jpg";